import { Injectable } from "@angular/core";
import { DateTime, Settings } from "luxon";
import { Adapter } from "src/app/core/adapter";
import { Model } from "src/app/core/models/model";
import { GraphElementDto } from "src/app/shared/components/graph/dto/graph-element-dto";

export class MeterSignalElement implements Model, GraphElementDto {
  public get xLabel(): String {
    return this.date.toISO();
  }
  public get barValue(): number {
    return this.volume;
  }
  public get lineValue(): number {
    return this.temperature ? Math.round(this.temperature * 10) / 10 : null;
  }

  public get line2Value(): number {
    return this.conductivity;
  }
  public get bar2Value(): number {
    return this.calculated_volume;
  }
  public barStyle: string = null;

  public static GetEmptySignalElement(date: DateTime) {
    return new MeterSignalElement(date, 0, 0, 0, 0, 0, 0, false);
  }

  constructor(
    public date: DateTime,
    public duration: number,
    public volume: number,
    public calculated_volume: number,
    public flow: number,
    public temperature: number,
    public conductivity: number,
    public label_confirmed: boolean
  ) {}
}

export type MeterSignalsMap = { [key: string]: MeterSignalElement[] };

@Injectable({
  providedIn: "root",
})
export class MeterSignalAdapter implements Adapter<MeterSignalElement> {
  constructor() {}

  adapt(item: any): MeterSignalElement {
    return new MeterSignalElement(
      DateTime.fromISO(item.date, { zone: Settings.defaultZone }),
      item.duration,
      item.volume,
      item.calculated_volume,
      item.flow,
      item.temperature,
      item.conductivity,
      item.label_confirmed
    );
  }
}
